<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      业务员统计
    </div>

    <el-form
      ref="ruleForm"
      :model="ruleForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <!-- <el-form-item label="选择城市" prop="name">
          <el-select v-model="ruleForm.region" placeholder="请选择活动区域">
      <el-option label="区域一" value="shanghai"></el-option>
      <el-option label="区域二" value="beijing"></el-option>
    </el-select>
      </el-form-item> -->

      <el-form-item label="选择区域">
        <el-cascader
          :props="optionProps"
          v-model="regionId"
          :options="city"
          @change="handleChange"
          clearable
        ></el-cascader>
      </el-form-item>

      <!--  <el-form-item label="请选择行政区划" prop="cityDetailId">
        <el-cascader :props="optionProps" v-model="regionId" :options="city" @change="handleChange" clearable></el-cascader>
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getconzi">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="业务区域" prop="regionName"> </el-table-column>

      <el-table-column label="业务员总数" prop="num"> </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getchakxq(scope.row.cityId)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import options from "../../../city.json";
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      regionId: [],
      cityId: "",
      city: [],
      optionProps: {
        value: "regionId",
        label: "regionName",
        children: "child",
      },
      tableData: [],
      ruleForm: {
        region: "",
      },
    };
  },

  created() {
    this.city = options;
    this.getCityTotal();
  },

  methods: {
    getconzi() {
        this.regionId="",
      (this.cityId = ""),
       this.getCityTotal();
    },

    getchaxu() {
      this.getCityTotal();
    },

    handleChange(value) {
      console.log(value);

      this.cityId= value[2];

      // this.cityId = a + "";

      // this.cityId = this.cityId.slice(0, 4);

      console.log();
    },

    getCityTotal() {
      this.$api.activitymsg
        .getCityTotal({
          cityId: this.cityId,
        })
        .then((e) => {
          this.tableData = e.data;
        });
    },

    getchakxq(id) {
      // this.$router.push('/index/chakang')

      this.$router.push({
        path: "/index/chakang",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
